/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs */

const en_admin_membership_confirmations_starts_after_allocation_error = /** @type {(inputs: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The membership can not start after any allocations start`)
};

const de_admin_membership_confirmations_starts_after_allocation_error = /** @type {(inputs: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Mitgliedschaft kann nicht nach dem Start einer Zuweisung beginnen`)
};

const es_admin_membership_confirmations_starts_after_allocation_error = /** @type {(inputs: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La suscripción no puede comenzar después del inicio de ninguna asignación`)
};

const fr_admin_membership_confirmations_starts_after_allocation_error = /** @type {(inputs: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'abonnement ne peut pas commencer après le début d'une attribution`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs) => LocalizedString} */
const it_admin_membership_confirmations_starts_after_allocation_error = en_admin_membership_confirmations_starts_after_allocation_error;

/** @type {(inputs: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_starts_after_allocation_error = en_admin_membership_confirmations_starts_after_allocation_error;

/** @type {(inputs: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs) => LocalizedString} */
const pl_admin_membership_confirmations_starts_after_allocation_error = en_admin_membership_confirmations_starts_after_allocation_error;

/** @type {(inputs: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs) => LocalizedString} */
const hu_admin_membership_confirmations_starts_after_allocation_error = en_admin_membership_confirmations_starts_after_allocation_error;

/** @type {(inputs: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs) => LocalizedString} */
const ro_admin_membership_confirmations_starts_after_allocation_error = en_admin_membership_confirmations_starts_after_allocation_error;

/**
* | output |
* | --- |
* | "The membership can not start after any allocations start" |
*
* @param {Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_starts_after_allocation_error = /** @type {((inputs?: Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Starts_After_Allocation_ErrorInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_starts_after_allocation_error(inputs)
	if (locale === "de") return de_admin_membership_confirmations_starts_after_allocation_error(inputs)
	if (locale === "es") return es_admin_membership_confirmations_starts_after_allocation_error(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_starts_after_allocation_error(inputs)
	if (locale === "it") return it_admin_membership_confirmations_starts_after_allocation_error(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_starts_after_allocation_error(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_starts_after_allocation_error(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_starts_after_allocation_error(inputs)
	return ro_admin_membership_confirmations_starts_after_allocation_error(inputs)
});
export { admin_membership_confirmations_starts_after_allocation_error as "admin.membership_confirmations.starts_after_allocation_error" }